import { useReducer, useMemo, Dispatch } from 'react';

import { FlexDetails } from 'ggApp/types/graphql';

import useAction from '../../hooks/useAction';

import reducer, { SubscriptionDataStateType } from './reducer';
import { setSubscriptionData as setSubscriptionDataAction, Action } from './actions';

function useActions(dispatch: Dispatch<Action>): SubscriptionDataActions {
    const setSubscriptionData = useAction<FlexDetails, Action>(dispatch, setSubscriptionDataAction);

    const actions = useMemo(
        () => ({
            setSubscriptionData,
        }),
        [setSubscriptionData],
    );

    return actions;
}

function useSubscriptionDataState(): SubscriptionDataState {
    const [state, dispatch] = useReducer(reducer, null);
    const actions = useActions(dispatch);

    const subscriptionDataState = useMemo(
        () => ({
            subscriptionData: state,
            actions,
        }),
        [state, actions],
    );

    return subscriptionDataState;
}

export default useSubscriptionDataState;

export interface SubscriptionDataActions {
    setSubscriptionData: (param: FlexDetails) => void;
}

export interface SubscriptionDataState {
    subscriptionData: SubscriptionDataStateType;
    actions: SubscriptionDataActions;
}
